import { render } from "./SiteNav.vue?vue&type=template&id=14085dea&scoped=true"
import script from "./SiteNav.vue?vue&type=script&lang=js"
export * from "./SiteNav.vue?vue&type=script&lang=js"

import "./SiteNav.vue?vue&type=style&index=0&id=14085dea&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-14085dea"

export default script